import { render, staticRenderFns } from "./selectRecord.vue?vue&type=template&id=7022c87e&"
import script from "./selectRecord.vue?vue&type=script&lang=js&"
export * from "./selectRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports